"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISPOSITION_SALE_TYPES = exports.DISPOSITION_COUNTERPARTY_TYPES = exports.DISPOSITION_STATUSES = void 0;
exports.DISPOSITION_STATUSES = {
    ACTIVE_ON_MLS: 'active_on_mls',
    CANCELED: 'canceled',
    CLEAR_TO_CLOSE: 'clear_to_close',
    LISTING_PREP: 'listing_prep',
    PENDING_DUE_DILIGENCE: 'pending_due_diligence',
    PENDING_MOVE_OUT: 'pending_move_out',
    PENDING_TURN: 'pending_turn',
    PRE_CONTRACT_AGREEMENT: 'pre_contract_agreement',
    READY_TO_LIST: 'ready_to_list',
    SOLD: 'sold'
};
exports.DISPOSITION_COUNTERPARTY_TYPES = {
    CUSTOMER: 'customer',
    INVESTOR: 'investor',
    OWNER_OCCUPANT: 'owner_occupant'
};
exports.DISPOSITION_SALE_TYPES = {
    SALE_TO_MARKET: 'sale_to_market',
    CUSTOMER_PURCHASE: 'customer_purchase',
    CUSTOMER_PURCHASE_OR_SALE_TO_MARKET: 'customer_purchase_or_sale_to_market'
};
